<template>
	<load
		v-if="loading"
		mode="table"
		class="mt-0"
		color="#f0f8ff"
		message="Carregando conversa"
		style="height: 100% !important"
	/>
	<div class="container-fluid px-0" v-else>
		<div class="row">
			<div
				class="col-12 pt-2 d-flex justify-content-between align-items-center px-2"
				v-if="loadingConversation == false"
			>
				<h3 class="box-title mb-0 ml-2">
					<i class="mdi mdi-24px mdi-wrench"></i>
					Atendimento demandas <b>SUAS</b>Fácil
				</h3>
				<h4
					class="mb-0 px-3"
					:class="demanda.status == 1 ? 'text-danger' : 'text-success'"
					v-if="mode == 'page' && demanda"
				>
					<Button
						class="btn btn-primary"
						v-if="demanda.status == 2"
						@click="$emit('novo')"
					>
						Novo demanda
					</Button>
					{{ demanda.status == 1 ? "ABERTO" : demanda.status ? "RESOLVIDO" : "" }}
				</h4>
				<div class="box-tools pull-right mb-0" v-if="mode != 'page'">
					<button
						class="btn btn-box-tool btn-chat-fechar m-0 px-1 text-danger"
						v-on:click="
							$emit('minimizar');
							$emit('clear');
						"
					>
						<i class="mdi mdi-close"></i>
					</button>
				</div>
			</div>
		</div>
		<div
			:style="
				mode == 'page' ? 'height: calc(100vh - 190px)' : 'height: calc(100vh - 260px)'
			"
			class="rounded back"
		>
			<Conversation
				:load="loadingConversation"
				:contact="selectedContact"
				:messages="messages"
				:sending="sending"
				:writemessage="writemessage"
				:writedemandaname="write_demanda_name"
				:status="status"
				:demanda="demanda"
				@sending="sending = true"
				@completed="reloadPage"
				@new="onMessage"
				@writing="writingMessage(true)"
				@stop-writing="writingMessage(false)"
			/>
		</div>
	</div>
</template>

<script>
import Conversation from "./Conversation";
import UnreadComponent from "./UnreadComponent";
import { FlowerSpinner } from "epic-spinners";
import socket from "@/dashboard/socket";

export default {
	name: "BoxChatDemanda",
	components: {
		Conversation,
		UnreadComponent,
		FlowerSpinner,
	},
	props: ["minimizar", "mode", "selected"],
	data() {
		return {
			loading: false,
			hasNewMessages: false,
			sending: false,
			selectedContact: null,
			demanda: null,
			messages: [],
			newmessage: "",
			loadingConversation: false,
			urlsound: `${window.location.protocol}//${window.location.host}sound/alert.mp3`,
			urlApp: `${window.location.protocol}//${window.location.host}`,
			showContacts: false,
			writemessage: false,
			write_demanda_name: "",
			status: 1,
		};
	},

	created() {
		// let userID = this.$store.state.user.id;
		// let username = this.$store.state.user.name;
		// // let path = this.$store.state.settings.path;
		// socket.auth = { userID, username };
		// socket.userID = userID;
		// socket.connect();

		// socket.emit(
		// 	"set user logado",
		// 	this.$store.state.user,
		// 	this.$store.state.settings.path
		// );
		socket.on("set private message", (content, name) => {
			// if (this.demanda.contact.tecnico_id == content.from) {
			if (content.from == "Gestao.Demanda") {
				axios
					.post("api/dashboard/demanda/conversation/send", {
						type: "send_demanda",
						text: content.text,
						demanda: name,
					})
					.then((response) => {
						this.messages.push(response.data);
					})
					.finally(() => {
						swal.fire({
							toast: true,
							position: "top-end",
							icon: "success",
							title: "Nova mensagem no canal de demanda",
							showConfirmButton: false,
							timerProgressBar: true,
							timer: 3000,
						});
					});
			}
			// }
		});
		this.startConversation();
		socket.on("writing", (content, name) => {
			this.writemessage = true;
			this.write_demanda_name = name;
		});
		socket.on("stop writing", (content, name) => {
			this.writemessage = false;
			this.write_demanda_name = name;
		});
		socket.on("support close", (name) => {
			swal.fire({
				text: `A demanda foi finalizado por ${name}.`,
				icon: "warning",
				showConfirmButton: false,
				timer: 3000,
			});
			this.startConversation(this.selected);
		});
		socket.on("reload", (name) => {
			this.startConversation(this.selected, false);
		});
	},
	watch: {
		selected() {
			//console.log(this.selected);
			this.startConversation(this.selected);
		},
	},
	methods: {
		reloadPage() {
			this.startConversation(this.selected, false);
			// let path = this.$store.state.settings.path;
			let user = this.$store.state.user;
			socket.emit(
				"private message support reload",
				this.urlApp,
				user.id,
				user.name,
				"cliente",
				true
			);
		},
		startConversation(selected = null, load = true) {
			this.loading = load;
			// this.loadingConversation = load;
			var id = selected != null ? selected : 0;

			this.sending = false;
			axios.get(`api/dashboard/demanda/conversation/${id}`).then((response) => {
				this.demanda = response.data;
				this.status = this.demanda ? this.demanda.status : 1;
				this.messages = response.data.messages;
				this.loading = false;
				// this.loadingConversation = false;
			});
		},
		beep() {
			var audio = document.getElementById("audio");
			if (audio) {
				let startPlayPromise = audio.play();

				if (startPlayPromise !== undefined) {
					startPlayPromise
						.then(() => {
							// Start whatever you need to do only after playback
							// has begun.
						})
						.catch((error) => {
							if (error.name === "NotAllowedError") {
								// showPlayButton(audio);
							} else {
								// Handle a load or playback error
							}
						});
				}
			}
		},
		onMessage(data) {
			let message = data.text;
			// let path = this.$store.state.settings.path;
			data.to = "demanda";

			this.sending = true;
			if (this.messages !== undefined) {
				this.messages.push(data);
			} else {
				this.messages = [
					{
						id: data.id,
						from: data.from,
						to: data.to,
						demanda_id: data.demanda_id,
						text: data.text,
						created_at: data.created_at,
					},
				];
			}

			socket.emit(
				"private message support",
				data,
				this.urlApp,
				"cliente",
				null,
				true
			);
			this.startConversation(null, false);
		},
		writingMessage(status) {
			// let path = this.$store.state.settings.path;
			let user = this.$store.state.user;
			let destino = "Gestao.Demanda";
			socket.emit("writing", destino, user, this.urlApp, status, "demanda");
		},
	},
};
</script>

<style lang="css" scoped>
.nav-link {
	cursor: pointer;
}
.list-group-item {
	position: relative;
	display: block;
	padding: 0.75rem 1.25rem;
	background-color: #fff;
	border: 0 !important;
	border-bottom: 1px solid #f4f4f4 !important;
	cursor: pointer;
	font-weight: bold;
	font-size: 14px;
	text-transform: uppercase;
}
.list-group-item:hover {
	background: #f4f4f4;
}

::-webkit-scrollbar-track {
	background-color: #f4f4f4;
}
::-webkit-scrollbar {
	width: 5px;
	background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
	background: #979797;
	border-radius: 25em;
}

.morris-hover {
	position: absolute;
	z-index: 99 !important;
}
.new-btn-chat {
	display: flex;
	width: 45px;
	height: 45px;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	border: 0;
	background: #1f89e5;
	color: #fff;
	border-radius: 50%;
	transition: all 0.2s;
	-webkit-transform: scale(1);
	-moz-transform: scale(1);
	-o-transform: scale(1);
	transform: scale(1);
	border: 2px solid #fff;
}

.new-btn-chat:hover {
	background: #44a8ff;
	box-shadow: 0 20px 30px rgba(0, 0, 0, 0.3);
	-webkit-transform: scale(1.4);
	-moz-transform: scale(1.4);
	-o-transform: scale(1.4);
	transform: scale(1.4);
}

.btn-animated {
	animation: moveInBottom 5s ease-out;
	animation-fill-mode: backwards;
}
@keyframes moveInBottom {
	0% {
		opacity: 0;
		transform: scale(1.4);
	}

	100% {
		opacity: 1;
		transform: scale(0px);
	}
}

/* .btn-chat {
  font-size: 18px;
  color: #fff;
  background: #1f89e5;
  padding: 7.5px 10px 7.5px 10px;
  border-radius: 50%;
  box-shadow: 0 1px 4px 0px rgb(0 0 0 / 39%);
  cursor: pointer;
  z-index: 9999;
  min-height: 40px;
  max-height: 40px;
  height: 40px;
  overflow: hidden;
} */
/* .btn-chat:hover {
  background: #0d5a9e;
} */
.chat-app {
	display: flex;
}
.box-chat {
	position: fixed;
	z-index: 1001;
	bottom: 30px;
	right: 30px !important;
	display: block;
	width: 50%;
	height: calc(100% - 200px);
	overflow: hidden;
	border-radius: 2px;
	background: white;
	box-sizing: content-box;
	box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
	max-width: 800px;
	padding: 1rem;
	overflow: auto;
}

@media (min-width: 767px) AND (max-width: 1200px) {
	.box-chat {
		position: fixed;
		z-index: 1001;
		bottom: 40px;
		right: 40px !important;
		display: block;
		width: 70% !important;
		height: 70vh;
		overflow: hidden !important;
		border-radius: 2px;
		background: white;
		box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
		max-width: 800px;
		overflow: auto;
	}
}
@media (min-width: 567px) AND (max-width: 767px) {
	.box-chat {
		position: fixed;
		z-index: 9999;
		bottom: 60px;
		display: none;
		width: 90%;
	}
	.direct-chat-info {
		display: block;
		margin-bottom: 2px;
		font-size: 14px;
		width: 400px;
	}
}
@media (max-width: 567px) {
	.box-chat {
		position: fixed;
		z-index: 9999;
		bottom: 60px;
		display: none;
		width: 99%;
	}
	.direct-chat-info {
		display: block;
		margin-bottom: 2px;
		font-size: 14px;
		width: 300px;
	}
}
.back {
	background-color: #f0f8ff !important;
	background-image: radial-gradient(
		#b2dafd 1.1500000000000001px,
		#f0f8ff 1.1500000000000001px
	) !important;
	background-size: 23px 23px;
}
</style>
